import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=163a5d5c&"
import script from "./Challenge.vue?vue&type=script&lang=ts&"
export * from "./Challenge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports